import React, { useContext } from 'react';

export const SiteContext = React.createContext<Partial<Site.Site>>({ host: 'localhost', culture: 'en-US' });

export interface SiteContextProviderProps {
	site: Site.Site;
	children?: React.ReactNode;
}
export const SiteContextProvider: React.FC<SiteContextProviderProps> = ({ site, children }) => {
	return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
};

export function useSiteContext(): Partial<Site.Site> {
	return useContext(SiteContext);
}
